import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-6 sm:p-8" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-1" }, "Engagement"),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-extrabold text-[#1E2833]" }, "Post Comments")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "px-3 py-1 bg-gray-100 text-gray-600 text-xs font-bold rounded-full"
}
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center py-16"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 rounded-full border-4 border-[#6CC551] border-t-transparent animate-spin" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "bg-white rounded-2xl py-16 text-center",
  style: {"border":"1px dashed #e5e7eb"}
}
const _hoisted_9 = {
  class: "w-12 h-12 mx-auto mb-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  style: {"color":"#d1d5db"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-sm",
  style: {"color":"#9ca3af"}
}, "No comments yet.", -1)
const _hoisted_13 = {
  key: 2,
  class: "bg-white rounded-2xl overflow-hidden",
  style: {"border":"1px solid #f3f4f6"}
}
const _hoisted_14 = { class: "w-full text-sm text-left" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", {
  class: "text-xs text-[#1E2833] uppercase bg-[#6CC551]/10",
  style: {"border-bottom":"1px solid #f3f4f6"}
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "From"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "Post"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "Comment"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "Actions")
  ])
], -1)
const _hoisted_16 = { class: "px-5 py-4" }
const _hoisted_17 = {
  class: "font-medium",
  style: {"color":"#111827"}
}
const _hoisted_18 = {
  class: "text-xs",
  style: {"color":"#9ca3af"}
}
const _hoisted_19 = { class: "px-5 py-4 max-w-[180px]" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "px-5 py-4 max-w-xs" }
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "px-5 py-4" }
const _hoisted_24 = {
  class: "px-5 py-4 whitespace-nowrap text-xs",
  style: {"color":"#9ca3af"}
}
const _hoisted_25 = { class: "px-5 py-4" }
const _hoisted_26 = { class: "flex items-center gap-3" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden" }
const _hoisted_30 = {
  class: "flex items-start justify-between px-6 py-5",
  style: {"border-bottom":"1px solid #f3f4f6"}
}
const _hoisted_31 = { class: "min-w-0 pr-4" }
const _hoisted_32 = {
  class: "text-xs mb-0.5",
  style: {"color":"#9ca3af"}
}
const _hoisted_33 = { class: "text-sm font-bold text-[#1E2833] leading-snug truncate" }
const _hoisted_34 = { class: "text-sm text-[#6CC551] mt-0.5" }
const _hoisted_35 = {
  key: 0,
  class: "text-xs font-normal",
  style: {"color":"#9ca3af"}
}
const _hoisted_36 = {
  key: 0,
  class: "inline-flex items-center mt-1 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide",
  style: {"background":"rgba(108,197,81,0.12)","color":"#6CC551"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "px-6 py-5" }
const _hoisted_40 = {
  class: "text-sm leading-relaxed whitespace-pre-wrap",
  style: {"color":"#374151"}
}
const _hoisted_41 = {
  class: "px-6 py-4 flex items-center justify-end gap-3",
  style: {"background":"#f9fafb","border-top":"1px solid #f3f4f6"}
}

import { onMounted, ref } from 'vue';
import axios from 'axios';
import { url } from '@/functions/endpoint';
import { authService } from '@/services/auth';

interface CommentUser {
  id: number;
  name: string;
  email: string;
}

interface CommentPost {
  id: number;
  title: string;
}

interface Comment {
  id: number;
  message: string;
  createdAt: string;
  user: CommentUser | null;
  post: CommentPost | null;
  replyTo: { id: number } | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewComments',
  setup(__props) {

const comments = ref<Comment[]>([]);
const loading  = ref(true);
const selected = ref<Comment | null>(null);

const headers = () => ({ Authorization: authService.getToken() ?? '' });

const formatDate = (d: string) =>
  new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

const fetchComments = async () => {
  loading.value = true;
  try {
    const res = await axios.get(`${url}/comment`, { headers: headers() });
    comments.value = res.data;
  } finally {
    loading.value = false;
  }
};

const deleteComment = async (id: number) => {
  if (!confirm('Delete this comment?')) return;
  try {
    await axios.delete(`${url}/comment/${id}`, { headers: headers() });
    comments.value = comments.value.filter((c) => c.id !== id);
  } catch {}
};

onMounted(fetchComments);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (comments.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(comments.value.length) + " total ", 1))
        : _createCommentVNode("", true)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (!comments.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11)),
            _hoisted_12
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("table", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comments.value, (c) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: c.id,
                    class: "transition-colors",
                    style: {"border-bottom":"1px solid #f9fafb"},
                    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (($event.currentTarget as HTMLElement).style.background='#f9fafb')),
                    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (($event.currentTarget as HTMLElement).style.background=''))
                  }, [
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(c.user?.name ?? '—'), 1),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(c.user?.email ?? ''), 1)
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("p", {
                        class: "truncate text-xs font-medium",
                        style: {"color":"#374151"},
                        title: c.post?.title
                      }, _toDisplayString(c.post?.title ?? '—'), 9, _hoisted_20)
                    ]),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("p", {
                        class: "truncate text-xs",
                        style: {"color":"#6b7280"},
                        title: c.message
                      }, _toDisplayString(c.message), 9, _hoisted_22)
                    ]),
                    _createElementVNode("td", _hoisted_23, [
                      _createElementVNode("span", {
                        class: "inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide",
                        style: _normalizeStyle(c.replyTo
                  ? 'background: rgba(108,197,81,0.12); color: #6CC551;'
                  : 'background: #f3f4f6; color: #6b7280;')
                      }, _toDisplayString(c.replyTo ? 'Reply' : 'Comment'), 5)
                    ]),
                    _createElementVNode("td", _hoisted_24, _toDisplayString(formatDate(c.createdAt)), 1),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (selected.value = c),
                          class: "text-xs font-semibold text-[#6CC551] hover:underline"
                        }, "View", 8, _hoisted_27),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (deleteComment(c.id)),
                          class: "text-xs font-semibold text-red-500 hover:underline"
                        }, "Delete", 8, _hoisted_28)
                      ])
                    ])
                  ], 32))
                }), 128))
              ])
            ])
          ])),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-150",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (selected.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40",
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (selected.value = null), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("p", _hoisted_32, _toDisplayString(formatDate(selected.value.createdAt)), 1),
                    _createElementVNode("p", _hoisted_33, _toDisplayString(selected.value.post?.title ?? 'Unknown post'), 1),
                    _createElementVNode("p", _hoisted_34, [
                      _createTextVNode(_toDisplayString(selected.value.user?.name ?? 'Anonymous') + " ", 1),
                      (selected.value.user?.email)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, " · " + _toDisplayString(selected.value.user.email), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (selected.value.replyTo)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, " Reply "))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (selected.value = null)),
                    style: {"color":"#9ca3af","flex-shrink":"0"},
                    onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (($event.currentTarget as HTMLElement).style.color='#4b5563')),
                    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (($event.currentTarget as HTMLElement).style.color='#9ca3af'))
                  }, _hoisted_38, 32)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("p", _hoisted_40, _toDisplayString(selected.value.message), 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => {deleteComment(selected.value.id); selected.value = null}),
                    class: "px-4 py-2 text-sm font-semibold text-red-500 hover:bg-red-50 rounded-xl transition-colors"
                  }, " Delete "),
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (selected.value = null)),
                    class: "px-4 py-2 text-sm font-semibold text-gray-500 hover:bg-gray-100 rounded-xl transition-colors"
                  }, " Close ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})